import { MemberBasicsFragment } from '../graphql/types';

export const getMemberName = (
  member?:
    | Pick<MemberBasicsFragment, 'firstName' | 'lastName'>
    | null
    | undefined,
  options?: {
    lastNameInitial?: boolean;
  },
) => {
  const { firstName, lastName } = member || {};

  const formattedLastName =
    lastName && options?.lastNameInitial ? `${lastName[0]}.` : lastName;

  if (firstName && formattedLastName) {
    return `${firstName} ${formattedLastName}`;
  }

  if (firstName) {
    return firstName;
  }

  if (formattedLastName) {
    return formattedLastName;
  }

  return 'Unknown member';
};
